import { IEquipmentWeightInfo } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View, ViewStyle } from 'react-native';
import Theme from '../../theme';
import { EquipmentOptionInstruction } from '../../utils';
import { defaultScale } from '../../utils/scaling';

interface IProps {
  width: number | string;
  height: number | string;
  equipmentWeightInfo: IEquipmentWeightInfo;
  containerStyle: ViewStyle;
  useAlphaFeatures: boolean;
}

class EquipmentInstructionComponent extends PureComponent<IProps, any> {
  public render() {
    const { containerStyle, equipmentWeightInfo } = this.props;
    const instruction = EquipmentOptionInstruction[equipmentWeightInfo.equipment];
    const description = equipmentWeightInfo.description;
    const color = equipmentWeightInfo.color;
    return (
      <View style={[styles.container, containerStyle]}>
        {instruction.image}
        <Text style={styles.description}>{description}</Text>
        <View style={styles.resistanceContainer}>
          {color && <View style={[
            styles.resistanceIndicator,
            { backgroundColor: color },
          ]}
          />}
          <Text style={styles.resistanceText}>
            {equipmentWeightInfo.equipmentWeight}
          </Text>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
  },
  description: {
    ...Theme.textStyle.heading2,
    marginTop: defaultScale(10),
    fontSize: defaultScale(16),
    color: Theme.WHITE,
    opacity: 0.5,
  },
  resistanceContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: defaultScale(10),
  },
  resistanceIndicator:{
    height: defaultScale(20),
    width: defaultScale(35),
    marginRight: defaultScale(10),
  },
  resistanceText: {
    ...Theme.textStyle.heading2,
    fontSize: defaultScale(16),
    color: Theme.WHITE,
    opacity: 0.5,
  },
});

export const EquipmentInstruction = translate(['homeWorkouts'], { wait: true })(
  EquipmentInstructionComponent,
);
